/**
 * Quote line templates for quick data entry
 */

export const templates = [
  {
    name: 'Factory New OEM',
    data: { condition: 'FN', cert_name: 'OEM', lead_time: 14 }
  },
  {
    name: 'New Surplus OEM',
    data: { condition: 'NS', cert_name: 'OEM', lead_time: 21 }
  },
  {
    name: 'Overhauled 8130',
    data: { condition: 'OH', cert_name: '8130', lead_time: 30 }
  },
  {
    name: 'Serviceable EASA',
    data: { condition: 'SV', cert_name: 'EASA', lead_time: 45 }
  }
];
